module.exports = __webpack_public_path__ + "img/file-icon.00b52b9e.svg";